
<div>

    <mce-project-header [project]="project()"></mce-project-header>

    <div class="mce-form-section">

        <div class="mce-form-section-title">Project Users</div>

        @if (vm.disableRemoveUser) {
        <mce-info-message type="error">
            Each project needs at least one user.
            The last user cannot be removed from a project.
        </mce-info-message>
        }


        <mat-toolbar>
            <mat-toolbar-row class="mce-datatable-toolbar-row">
                <button mat-raised-button color="primary"
                        (click)="addUser()">
                    <mat-icon>add</mat-icon>Add User
                </button>
            </mat-toolbar-row>
        </mat-toolbar>


        <mce-data-table [displayedColumns]="vm.dataTable.displayedColumns"
                        [data]="vm.dataTable.data"
                        [headers]="vm.dataTable.headers"
                        [cellTemplates]="vm.dataTable.templates">

            <ng-template #rowActions let-row="row">

                <button mat-icon-button (click)="removeUser(row)" [disabled]="vm.disableRemoveUser">
                    <mat-icon>close</mat-icon>
                </button>

            </ng-template>

            <ng-template #photo let-data let-row="row">
                <div class="profile-photo-sm p-2">
                    <img src={{row.photoUrl.value}} />
                </div>
            </ng-template>

        </mce-data-table>

        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
        </mce-save-cancel>

    </div>

    @if (vm.showLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

</div>

@if (vm.showSpinner) {
<div class="spinner">
    <mat-spinner test-id="spinner"></mat-spinner>
</div>
}

